/* ============================================================================
   Joe's Kitchen — Dark "Crave" Catering interactions
   Each tray card carries its product's variant matrix (embedded JSON). Pills
   are the product's option values; selecting them resolves a real variant whose
   price is the true total. Add / in-order steppers drive the live Shopify cart
   via window.JK (jk-chrome.js).
   ============================================================================ */
(function () {
  const money = (cents) => (window.JK && window.JK.money ? window.JK.money(cents) : '$' + (cents / 100).toFixed(2));
  const I = (n) => (window.JK && window.JK.icon ? window.JK.icon(n) : '');
  const BACK = '<span class="mask"><svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 2.5 4.5 7 9 11.5"></path></svg></span>';

  const grid = document.getElementById('jkCatGrid');
  if (!grid) return;

  function data(card) {
    if (card._data) return card._data;
    try { card._data = JSON.parse(card.querySelector('.cc-data').textContent); }
    catch (e) { card._data = { options: [], variants: [] }; }
    if (card._lq == null) card._lq = 1;
    return card._data;
  }

  function selectedValues(card) {
    return Array.from(card.querySelectorAll('.cc-pills')).map((g) => {
      const a = g.querySelector('.cc-pill.active');
      return a ? a.dataset.value : null;
    });
  }

  function resolveVariant(card) {
    const d = data(card);
    const sel = selectedValues(card).join(' / ');
    return d.variants.find((v) => v.options.join(' / ') === sel) || null;
  }

  function servings(optName, value) {
    if ((optName || '').toLowerCase() !== 'size') return '';
    if (value === 'Half Pan') return 'Serves 8–10';
    if (value === 'Full Pan') return 'Serves 16–20';
    return '';
  }

  function renderServings(card) {
    const d = data(card);
    card.querySelectorAll('.cc-pills').forEach((g, i) => {
      const a = g.querySelector('.cc-pill.active');
      const lbl = card.querySelector('.cc-opt-label[data-key="' + i + '"] .serves');
      if (lbl) lbl.textContent = a ? servings(d.options[i], a.dataset.value) : '';
    });
  }

  function cartLineFor(variantId) {
    const cart = window.JK ? window.JK.getCart() : null;
    if (!cart || !cart.items) return null;
    return cart.items.find((it) => it.id === variantId) || null;
  }

  function productQty(card) {
    const cart = window.JK ? window.JK.getCart() : null;
    if (!cart || !cart.items) return 0;
    const ids = data(card).variants.map((v) => v.id);
    return cart.items.filter((it) => ids.indexOf(it.id) > -1).reduce((s, it) => s + it.quantity, 0);
  }

  function renderAction(card) {
    const variant = resolveVariant(card);
    const priceEl = card.querySelector('.cc-modal-price');
    const action = card.querySelector('.cc-action');
    const line = variant ? cartLineFor(variant.id) : null;
    const inCart = line ? line.quantity : 0;
    const unitPrice = variant ? variant.price : data(card).minPrice;
    if (priceEl) priceEl.textContent = inCart > 0 ? money(unitPrice * inCart) : money(unitPrice);
    if (!action) return;
    if (inCart > 0) {
      action.innerHTML =
        '<div class="cc-inorder">' +
          '<span class="lbl">' + I('check') + ' In your order</span>' +
          '<div class="cc-stepper">' +
            '<button data-act="cdec" data-key="' + line.key + '" class="' + (inCart === 1 ? 'danger' : '') + '" aria-label="' + (inCart === 1 ? 'Remove' : 'Decrease') + '">' + (inCart === 1 ? I('close') : I('minus')) + '</button>' +
            '<span class="q">' + inCart + '</span>' +
            '<button data-act="cinc" data-key="' + line.key + '" aria-label="Add one">' + I('plus') + '</button>' +
          '</div>' +
        '</div>';
    } else {
      const lq = card._lq || 1;
      const canAdd = variant && variant.available;
      action.innerHTML =
        '<div class="cc-stepper">' +
          '<button data-act="ldec" class="' + (lq <= 1 ? 'disabled' : '') + '" aria-label="Decrease">' + I('minus') + '</button>' +
          '<span class="q">' + lq + '</span>' +
          '<button data-act="linc" aria-label="Increase">' + I('plus') + '</button>' +
        '</div>' +
        '<button class="cc-add" data-act="add"' + (canAdd ? '' : ' disabled') + '>' + (variant && !variant.available ? 'Sold out' : 'Add to Order') + '</button>';
    }
  }

  function syncCard(card) {
    const total = productQty(card);
    let badge = card.querySelector('.cc-qty');
    if (total > 0) {
      if (!badge) { badge = document.createElement('div'); badge.className = 'cc-qty'; card.querySelector('.cc-img').appendChild(badge); }
      badge.innerHTML = I('check') + ' ' + total;
      card.classList.add('added');
    } else {
      if (badge) badge.remove();
      card.classList.remove('added');
    }
    renderServings(card);
    renderAction(card);
  }
  const syncAll = () => grid.querySelectorAll('.cat-card').forEach(syncCard);

  function closeModal(card) { card.classList.remove('modal-open'); const m = card.querySelector('.cc-modal'); if (m) m.classList.remove('active'); }
  function openModal(card) {
    grid.querySelectorAll('.cat-card.modal-open').forEach((c) => { if (c !== card) closeModal(c); });
    card.classList.add('modal-open');
    card.querySelector('.cc-modal').classList.add('active');
    renderAction(card);
  }

  grid.addEventListener('click', (e) => {
    const card = e.target.closest('.cat-card');
    if (!card) return;
    if (e.target.closest('[data-open]')) { openModal(card); return; }
    if (e.target.closest('[data-close]')) { closeModal(card); return; }

    const pill = e.target.closest('.cc-pill');
    if (pill && !pill.disabled) {
      const group = pill.closest('.cc-pills');
      group.querySelectorAll('.cc-pill').forEach((p) => p.classList.toggle('active', p === pill));
      renderServings(card); renderAction(card);
      return;
    }

    const actBtn = e.target.closest('[data-act]');
    if (!actBtn) return;
    const act = actBtn.dataset.act;
    if (act === 'linc') { card._lq = (card._lq || 1) + 1; renderAction(card); }
    else if (act === 'ldec') { card._lq = Math.max(1, (card._lq || 1) - 1); renderAction(card); }
    else if (act === 'add') {
      const variant = resolveVariant(card);
      if (!variant || !variant.available || !window.JK) return;
      actBtn.disabled = true;
      window.JK.add(variant.id, card._lq || 1)
        .then(() => { card._lq = 1; })
        .catch((err) => { alert(err.message || 'Could not add to cart'); actBtn.disabled = false; });
    }
    else if (act === 'cinc') {
      const line = cartLineFor(resolveVariant(card).id);
      if (line) window.JK.changeQty(line.key, line.quantity + 1);
    }
    else if (act === 'cdec') {
      const line = cartLineFor(resolveVariant(card).id);
      if (line) window.JK.changeQty(line.key, line.quantity - 1);
    }
  });

  document.addEventListener('click', (e) => {
    // Ignore clicks whose target was re-rendered out of the DOM (e.g. the qty
    // stepper buttons rebuilt by renderAction) — otherwise closest() returns
    // null and the modal would wrongly close.
    if (!document.body.contains(e.target)) return;
    if (e.target.closest('.cat-card')) return;
    grid.querySelectorAll('.cat-card.modal-open').forEach(closeModal);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') grid.querySelectorAll('.cat-card.modal-open').forEach(closeModal); });

  window.addEventListener('jk-cart-change', syncAll);

  function start() { grid.querySelectorAll('.cat-card').forEach((c) => { data(c); }); syncAll(); }
  if (window.JK) start();
  else window.addEventListener('load', start);
})();
